/* Scoped, accessible image reader for the Boyfriend Application. */
(() => {
  const initialize = () => {
    document.querySelectorAll('zoom-dialog.cravynox-bf-reader').forEach(reader => {
      if (reader.dataset.bfReaderReady) return;
      reader.dataset.bfReaderReady = 'true';
      const dialog = reader.querySelector('dialog');
      if (!dialog) return;
      const controls = document.createElement('div');
      controls.className = 'bf-reader-controls';
      controls.setAttribute('role','group');
      controls.setAttribute('aria-label','Image magnification controls');
      controls.innerHTML = '<button type="button" data-bf-action="out" aria-label="Zoom out">−</button><output aria-live="polite">100%</output><button type="button" data-bf-action="in" aria-label="Zoom in">+</button><button type="button" data-bf-action="reset" aria-label="Fit image to screen" title="Fit to screen">Fit</button>';
      dialog.appendChild(controls);
      let scale=1, panX=0, panY=0;
      const imageItems=Array.from(dialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container--image'));
      const active=()=>imageItems.find(item=>{const r=item.getBoundingClientRect(),d=dialog.getBoundingClientRect();return r.left<d.right-30 && r.right>d.left+30 && r.top<d.bottom-30 && r.bottom>d.top+30;})||imageItems[0];
      const constrain=()=>{const item=active();const viewport=item?.querySelector('.bf-reader-viewport');const img=viewport?.querySelector('img.product-media__image');if(!viewport||!img||scale<=1){panX=0;panY=0;return;}const rect=viewport.getBoundingClientRect();const iw=img.naturalWidth||img.width,ih=img.naturalHeight||img.height;if(!rect.width||!rect.height||!iw||!ih)return;const fit=Math.min(rect.width/iw,rect.height/ih);const maxX=Math.max(0,(iw*fit*scale-rect.width)/2);const maxY=Math.max(0,(ih*fit*scale-rect.height)/2);panX=Math.max(-maxX,Math.min(maxX,panX));panY=Math.max(-maxY,Math.min(maxY,panY));};
      const apply=()=>{constrain();imageItems.forEach(item=>{item.style.setProperty('--bf-scale',scale);item.style.setProperty('--bf-pan-x',panX+'px');item.style.setProperty('--bf-pan-y',panY+'px');});controls.querySelector('output').textContent=Math.round(scale*100)+'%';};
      const reset=()=>{scale=1;panX=0;panY=0;apply();};
      controls.addEventListener('click',e=>{const action=e.target.closest('button')?.dataset.bfAction;if(!action)return;e.stopPropagation();if(action==='reset')reset();else{scale=Math.max(1,Math.min(3,Math.round((scale+(action==='in'?.25:-.25))*100)/100));if(scale===1){panX=0;panY=0;}apply();}});
      imageItems.forEach(item=>{
        const viewport=item.querySelector('.product-media__drag-zoom-wrapper')||item;
        viewport.classList.add('bf-reader-viewport');viewport.setAttribute('data-fit-initially','');
        const pointers=new Map();
        let gesture=null;
        const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
        const midpoint=(a,b)=>({x:(a.x+b.x)/2,y:(a.y+b.y)/2});
        const point=e=>({x:e.clientX,y:e.clientY});
        const beginGesture=()=>{
          const pts=Array.from(pointers.values());
          if(pts.length>=2){
            gesture={type:'pinch',distance:Math.max(1,distance(pts[0],pts[1])),scale,panX,panY,center:midpoint(pts[0],pts[1])};
          }else if(pts.length===1){
            gesture={type:'pan',start:pts[0],panX,panY};
          }else gesture=null;
        };
        item.addEventListener('click',e=>{e.stopImmediatePropagation();e.preventDefault();},true);
        viewport.addEventListener('pointerdown',e=>{
          if(e.pointerType==='mouse'&&e.button!==0)return;
          pointers.set(e.pointerId,point(e));
          try{viewport.setPointerCapture(e.pointerId);}catch(_){}
          beginGesture();
          if(e.pointerType==='touch')e.preventDefault();
        });
        viewport.addEventListener('pointermove',e=>{
          if(!pointers.has(e.pointerId))return;
          pointers.set(e.pointerId,point(e));
          const pts=Array.from(pointers.values());
          if(pts.length>=2&&gesture?.type==='pinch'){
            const center=midpoint(pts[0],pts[1]);
            const next=Math.max(1,Math.min(3,gesture.scale*distance(pts[0],pts[1])/gesture.distance));
            const ratio=next/gesture.scale;
            const bounds=viewport.getBoundingClientRect();
            const cx=gesture.center.x-(bounds.left+bounds.width/2);
            const cy=gesture.center.y-(bounds.top+bounds.height/2);
            panX=gesture.panX+(1-ratio)*cx+(center.x-gesture.center.x);
            panY=gesture.panY+(1-ratio)*cy+(center.y-gesture.center.y);
            scale=next;
            if(scale===1){panX=0;panY=0;}
            apply();
          }else if(pts.length===1&&gesture?.type==='pan'&&scale>1){
            panX=gesture.panX+pts[0].x-gesture.start.x;
            panY=gesture.panY+pts[0].y-gesture.start.y;
            apply();
          }
          if(e.pointerType==='touch')e.preventDefault();
        });
        const finishPointer=e=>{
          if(!pointers.has(e.pointerId))return;
          pointers.delete(e.pointerId);
          beginGesture();
        };
        viewport.addEventListener('pointerup',finishPointer);
        viewport.addEventListener('pointercancel',finishPointer);
        viewport.addEventListener('lostpointercapture',finishPointer);
        viewport.addEventListener('wheel',e=>{if(!e.ctrlKey&&!e.metaKey)return;e.preventDefault();scale=Math.max(1,Math.min(3,scale+(e.deltaY<0?.15:-.15)));if(scale===1){panX=0;panY=0;}apply();},{passive:false});
      });
      const observer=new MutationObserver(()=>{reset();});observer.observe(dialog,{attributes:true,attributeFilter:['open']});
      // Orientation changes alter the viewport: refit rather than retain stale pan offsets.
      let lastViewport = { width: window.innerWidth, height: window.innerHeight };
      window.addEventListener('resize', () => {
        const next = { width: window.innerWidth, height: window.innerHeight };
        if (next.width !== lastViewport.width || next.height !== lastViewport.height) reset();
        lastViewport = next;
      }, { passive: true });
      reader.querySelectorAll('.dialog-thumbnails-list button').forEach(button=>button.addEventListener('click',reset));
      apply();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
})();